import { IApplicationState } from '../../types/redux';

export function selectCurrentRegion(state: IApplicationState) {
  return state.geoLocation.currentRegion.id;
}
